import { SearchFilter } from './shared.constants';

export enum TICKET_STATUS {
  PENDING = 'TO_DO',
  ASSIGNED = 'ONGOING',
  CLOSED = 'CLOSED',
  EXTERNAL = 'EXTERNAL',
  ALL = 'ALL',
  ON_HOLD = 'ON_HOLD',
  ONGOING = 'ONGOING',
  PENDING_APPROVAL = 'PENDING_APPROVAL'
}

export const TICKETS_MENU = [
  {
    title: 'To-Do',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.PENDING,
  },
  {
    title: 'Ongoing',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ASSIGNED,
  },
  {
    title: 'On-Hold',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ON_HOLD,
  },
  {
    title: 'Closed',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.CLOSED,
  },
  {
    title: 'External',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.EXTERNAL,
  },
  {
    title: 'All',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ALL,
  },
];

export const TICKET_SEARCH_OPTIONS = [
  { title: 'Ticket No.', value: 'TICKET_NUMBER' },
  { title: 'Ticket Date', value: 'TICKET_DATE' },
  { title: 'Access / Asset name', value: 'ASSET_NAME' },
  { title: 'Raised By', value: 'TICKET_RAISED_BY' },
  { title: 'Assigned to', value: 'ASSIGNED_TO' },
];

export const TICKET_SORT_COLUMNS = {
  ASSET_NAME: 'ASSET_NAME',
  PRIORITY: 'PRIORITY',
  TICKET_NUMBER: 'TICKET_NUMBER',
  TICKET_DATE: 'TICKET_DATE',
  ASSET_TAG: 'ASSET_TAG',
  TICKET_STATUS: 'TICKET_STATUS',
  TICKET_RAISED_BY: 'TICKET_RAISED_BY',
  ASSIGNED_TO: 'ASSIGNED_TO',
};

export const TICKET_TYPES = {
  ASSET_ALLOCATION: 'ALLOCATION',
  REPAIR_OR_REPLACEMENT: 'REPAIR/REPLACEMENT',
  ACCESS_INSTALLATION: 'ACCESS/INSTALLATION',
  LICENSING: 'LICENSING',
  TOOL_ACCESS_REQUEST: 'TOOL_ACCESS_REQUEST',
  TOOL_ACCESS_RENEWAL: 'TOOL_ACCESS_RENEWAL',
  TOOL_ACCESS_REVOKE: 'TOOL_ACCESS_REVOKE',
};

export enum TICKET_STATES {
  SUCCESS = 'SUCCESS',
  DEFAULT = 'DEFAULT',
  ERROR = 'ERROR',
}

export const TICKET_PRIORITIES = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
};

export const EKO_TICKET_STATUS = [
  {
    title: 'To-Do',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.PENDING,
  },
  {
    title: 'Ongoing',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ASSIGNED,
  },
  {
    title: 'Closed',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.CLOSED,
  },
  {
    title: 'All',
    count: 0,
    route: '/home/admin-ticket/coditas',
    status: TICKET_STATUS.ALL,
  },
]

export const TICKET_PLACEHOLDERS = {
  CLOSED: { title: 'No Closed Tickets', subtitle: 'There are no Closed tickets' },
  TO_DO: { title: 'No To-DO Tickets', subtitle: 'There are no To-Do tickets' },
  ONGOING: { title: 'No Ongoing Tickets', subtitle: 'There are no Ongoing tickets' },
  ON_HOLD: { title: 'No On-HOLD Tickets', subtitle: 'There are no On-Hold tickets' },
  EXTERNAL: { title: 'No External Tickets', subtitle: 'There are no External tickets' },
  ALL: { title: 'No tickets generated yet', subtitle: 'Once you start generating tickets, they will appear here' },
  DEFAULT: { title: 'No tickets generated yet', subtitle: 'Once you start generating tickets, they will appear here' },
};

export const TICKETS_PLACEHOLDERS: Record<SearchFilter, string> = {
  TICKET_NUMBER: "Enter the ticket number (Eg - 2923)",
  TICKET_DATE: "Enter the ticket date (Eg - 19/09)",
  ASSET_NAME: "Enter the access/asset name (Eg - Laptop/cursor)",
  ASSET_TAG: "Enter the asset code (Eg - CSL-L-19-20-L-0002)",
  LOANEE: "Enter the loanee's name (Eg - John Doe)",
  TICKET_ASSIGNED_TO: "Enter the assignee's name (Eg - John Doe)",
  TICKET_RAISED_BY: "Enter the name (Eg - John Doe)",
  WORKSPACE_NAME: "Enter the workspace name",
  WORKSPACE_STATUS: "Enter the workspace status",
  ASSIGNED_TO: "Enter the assignee's name (Eg - John Doe)",
  DEFAULT: "Select an option to start searching",
  CLIENT_NAME: 'Enter the name of client (Eg - John Doe)',
  CREATED_BY: 'Enter the name (Eg - John Doe)',
  PROJECT_NAME: 'Enter the name of project'
};

export const TICKET_STATUS_MAP: Record<string, string> = {
  TO_DO: 'To-Do',
  ON_HOLD: 'On-Hold',
  ONGOING: 'Ongoing',
  CLOSED: 'Completed',
};

export const TICKET_FILTER = {
  ALL: 'all',
  ASSIGNED: 'assigned'
}

export const TICKET_URL = {
  ASSIGNED: '/home/admin-ticket/admin-employee-dashboard?ticketType=assigned'
}

export const SUB_CATEGORIES = {
  OTHER: 'Other',
  SOFTWARE_INSTALLATION: 'Software installation',
  WEBSITE_UNBLOCKING: 'Website Unblocking',
  GITHUB: 'GitHub',
  PROOFHUB: 'ProofHub',
};
